import {Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PageLayoutService} from '../../../../../../services/menu/page-layout.service';

@Component({
  selector: 'app-view360item',
  templateUrl: './view360item.component.html',
  styleUrls: ['./view360item.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class View360itemComponent implements OnInit {
  private _hideMiseEnAvant = false;
  private _hideEntete = false;

  @Output() action = new EventEmitter();
  @Input() path: string;
  @Input() caption: string;
  @Input() parent: string;
  @Input() default;
  @Input() hideActions: boolean;
  @Input() isVisible = true;
  @Input() ordre: number;

  @Input() set hideEntete(value: boolean) {
    this._hideEntete = true;
  }
  @Input() set hideMiseEnAvant(value: any) {
    this._hideMiseEnAvant = true;
  }


  get hideMiseEnAvant() {
    return this._hideMiseEnAvant;
  }

  get hideEntete() {
    return this._hideEntete;
  }

  @HostBinding('class') get classe() {
    return `view360_nav-element`;
  }
  constructor(route: ActivatedRoute, private pageLayoutService: PageLayoutService) {}

  ngOnInit() {
    this.pageLayoutService.addPageConfig(this);
    if (this.default != null) {
      this.action.next();
    }
  }
}
